import { ListItem } from "@mui/material";
import { Link } from "react-router-dom";

import HNSColors from "../../../../../../ui library/HNSColors";

const dataCellTypography = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "100%",
  letterSpacing: "0",
};

export default function ReportsListItem({ report, rowIndex }) {
  const isEvenRow = (rowIndex ?? 0) % 2 === 0;

  return (
    <Link to={"/reports/" + report.pk + "/"}>
      <ListItem
        className="group flex h-fit w-full gap-2 py-6"
        sx={{
          px: 2,
          backgroundColor: isEvenRow ? HNSColors.tertiary[950] : HNSColors.neutrals[900],
          borderTop: isEvenRow ? `1px solid ${HNSColors.primary[900]}` : "none",
          borderBottom: isEvenRow ? `1px solid ${HNSColors.primary[900]}` : "none",
          color: HNSColors.neutrals[100],
          transition: "background-color 150ms ease, color 150ms ease",
          "&:hover": {
            backgroundColor: HNSColors.primary[500],
            cursor: "pointer",
            color: HNSColors.neutrals[900],
          },
        }}
      >
        <div
          className="flex w-1/4 overflow-hidden text-ellipsis whitespace-nowrap md:block"
          style={dataCellTypography}
        >
          {!report.display_name ? "Untitled" : report.display_name}
        </div>
        <div
          className="flex w-3/4 overflow-hidden text-ellipsis whitespace-nowrap md:block"
          style={dataCellTypography}
        >
          {!report.description ? "No Description" : report.description}
        </div>
      </ListItem>
    </Link>
  );
}
